<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">{{
        $t("admin.transaction.add")
      }}</strong>
    </div>
    <div class="loader" v-if="loading"></div>
    <div v-else class="col-lg-12">
      <div class="card">
        <div class="add_content">
          <a-input-group compact>
            <a-select default-value="email" @change="handleChange">
              <a-select-option value="email"> Email </a-select-option>
              <a-select-option value="phone"> SĐT </a-select-option>
              <a-select-option value="uuid"> UUID </a-select-option>
            </a-select>
            <a-input
              v-on:keyup.enter="searchUser"
              ref="input"
              :placeholder="this.text"
              style="padding-left: 10px; width: 50%"
              type="text"
              v-model="value"
            />
          </a-input-group>
          <a-button
            @click="searchUser"
            type="primary"
            icon="search"
            style="margin-left: 20px"
            >Tìm kiếm
          </a-button>
        </div>
        <div v-if="boolUser" class="card-body">
          <a-form>
            <a-form-item
              label="Name:"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input v-model="data[0].name" :disabled="true" />
            </a-form-item>
            <a-form-item
              label="UID:"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input v-model="data[0].uid" :disabled="true" />
            </a-form-item>
            <a-form-item
              label="Phone Number:"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input v-model="data[0].phoneNumber" :disabled="true" />
            </a-form-item>
            <a-form-item
              label="Email:"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input v-model="data[0].email" :disabled="true" />
            </a-form-item>
            <a-form-item
              label="Coin đang có:"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input v-model="data[0].coin" :disabled="true" />
            </a-form-item>
            <a-form-item
              label="Số coin giao dịch:"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input-number v-model="coin" placeholder="Coin" />
            </a-form-item>

            <a-form-item
              label="Note:"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-textarea
                v-model="note"
                placeholder="Note"
                style="padding-left: 10px; width: 80%"
              />
            </a-form-item>

            <a-form-item
              label=" "
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-button
                type="primary"
                @click="addTransaction"
                :disabled="loading"
                >{{ $t("post.save") }}</a-button
              >
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  props: { data_new: Array, boolUser_new: Boolean },
  data() {
    return {
      loading: false,
      value: "",
      note: "",
      coin: "",
      data: "",
      boolUser: false,
      type: "email",
      text: "Nhập Email",
    };
  },
  methods: {
    load() {
      (this.data = this.data_new), (this.boolUser = this.boolUser_new);
    },
    addTransaction() {
      console.log("data", this.coin, this.note);
      if (!this.note || !this.coin || this.coin < 0) {
        alert("Yêu cầu nhập số coin và note vào!");
      } else {
        this.loading = true;
        this.api("admin/addTransaction", {
          uid: this.data[0].uid,
          coin: this.coin,
          note: this.note,
        })
          .then((res) => {
            console.log(res);
            // this.coin = "";
          })
          .finally((e) => {
            this.loading = false;
            alert("Tạo giao dịch thành công!");
            location.href = "/addtran";
          });
      }
    },
    searchUser() {
      if (this.value.length < 1 || !this.value) {
        alert("Dữ liệu trống");
      } else {
        this.loading = true;
        this.api(
          "admin/user?user=" +
            encodeURIComponent(this.value.trim()) +
            "&type=" +
            this.type
        )
          .then((res) => {
            if (res.message) {
              this.loading = false;
              alert(res.message);
            } else {
              res = res.map((resul) => {
                if (!resul.name) {
                  resul.name = "";
                }
                if (!resul.coin) {
                  resul.coin = 0;
                }
                if (!resul.phoneNumber) {
                  resul.phoneNumber = "";
                }
                return resul;
              });
              this.data = res;
              this.boolUser = true;
              console.log(this.data);
            }
          })
          .finally((e) => {
            this.loading = false;
          });
      }
    },
    handleChange(value) {
      console.log(`selected ${value}`);
      this.type = value;
      if (value == "phone") {
        this.text = "Nhập số điện thoại";
      }
      if (value == "uuid") {
        this.text = "Nhập uuid";
      }
      if (value == "email") {
        this.text = "Nhập email";
      }
    },
  },
  mounted() {
    this.load();
  },
  mixins: [api, helper],
};
</script>
<style scoped>
.user {
  margin-top: 20px;
  font-size: 14px;
}
.user-content {
  margin-top: 20px;
  display: flex;
  width: 80%;
  margin-left: 20px;
}
.user-content label {
  width: 180px;
  font-weight: bold;
}
.add_content {
  display: flex;
  width: 100%;
  background: #fff;
  padding: 1.92rem 2.3rem;
}
a {
  color: #ff5254;
}
a:hover {
  color: #08f;
}
/* loading */
.loader {
  border: 2px solid #f3f3f3;
  border-radius: 50%;
  border-top: 2px solid #ff8943;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
